import { useEffect, useState } from 'react'
import axios from 'axios'
import PageBanner from '../../shared/components/pageBanner/pageBanner'
import './helpFaq.css'
import Backdrop from '@mui/material/Backdrop';
import SyncLoader from "react-spinners/SyncLoader";
import { css } from "@emotion/react";


const HelpFaq = () => {

	const [info, setInfo] = useState();
	const [filter, setFilter] = useState("general");
	const [searchFlag, setSearchFlag] = useState(false);
	const [search, setSearch] = useState("");
	const [searchResults, setSearchResults] = useState([]);
	const [open, setOpen] = useState(true);

	const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
  `;

	useEffect(() => {
		window.scrollTo(0, 0)
		fetchData();
	}, [])

	useEffect(() => {
		if (info)
			setOpen(false);
	}, [info])

	useEffect(() => {
		if (search === "") {
			setSearchFlag(false);
			setSearchResults([]);
		}
		else {
			setSearchFlag(true);
			const results = info && info.filter(data => data.title.toLowerCase().includes(search.toLowerCase()));
			setSearchResults(results);
		}
	}, [search])

	const fetchData = async () => {
		const response = await axios.request({
			method: 'get',
			url: `${process.env.REACT_APP_SERVER_URL}/v1/cms/get-help-faq`
		})
		setInfo(response.data);
	}

	const handleChange = (e) => {
		setFilter(e.target.value);
	}
	console.log("Help/Faq-info: ", info);

	return (
		<div className="defaultLayout">
			<Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
				open={open}>
				<SyncLoader color={"#ff7e06"} loading={true} css={override} size={11} />
			</Backdrop>
			<div className="wrapper" id="helpFaq">
				<PageBanner check={true} setSearch={setSearch} />
				<div className="faqs-block">
					<div className="container">
						<div className="mb-3 mb-md-5 d-flex flex-column flex-md-row justify-content-md-between">
							<h2 className="mb-3 mb-md-0">Frequently Asked Question</h2>
							<div className="d-flex align-items-center">
								<span className="mr-3">Sorted by:</span>
								<div>
									<select id="categories" className="field-des" onChange={handleChange}>
										<option value="general" selected={filter === "general" ? true : false}>General</option>
										<option value="selling" selected={filter === "selling" ? true : false}>Selling</option>
										<option value="buying" selected={filter === "buying" ? true : false}>Buying</option>
									</select>
									
								</div>
							</div>
						</div>
						<div className="faqs-holder">
							<div id="accordion">
								{info && !searchFlag ? info.filter(faq => faq.type === filter).map((faq, key) => {
									return (
										<div className="card" key={key}>
											<div className="card-header" id={`heading${key}`}>
												<h5 className="mb-0">
													<button className={`btn btn-link ${key !== 0 ? "collapsed" : ""}`} data-toggle="collapse" data-target={`#collapse${key}`} aria-expanded={`${key === 0 ? true : false}`} aria-controls={`collapse${key}`}>
														<span>{faq.title}</span>
														<span className="arrow-icon ml-2">
															<i className="fa fa-angle-down"></i>
														</span>
													</button>
												</h5>
											</div>
											<div id={`collapse${key}`} className={`collapse ${key === 0 ? "show" : ""}`} aria-labelledby="headingOne" data-parent="#accordion">
												<div className="card-body">
													<p dangerouslySetInnerHTML={{ __html: faq.desc }}></p>
												</div>
											</div>
										</div>
									)
								}) : searchResults.filter(faq => faq.type === filter).map((faq, key) => {
									return (
										<div className="card" key={key}>
											<div className="card-header" id={`heading${key}`}>
												<h5 className="mb-0">
													<button className={`btn btn-link ${key !== 0 ? "collapsed" : ""}`} data-toggle="collapse" data-target={`#collapse${key}`} aria-expanded={`${key === 0 ? true : false}`} aria-controls={`collapse${key}`}>
														<span>{faq.title}</span>
														<span className="arrow-icon ml-2">
															<i className="fa fa-angle-down"></i>
														</span>
													</button>
												</h5>
											</div>
											<div id={`collapse${key}`} className={`collapse ${key === 0 ? "show" : ""}`} aria-labelledby="headingOne" data-parent="#accordion">
												<div className="card-body">
													<p dangerouslySetInnerHTML={{ __html: faq.desc }}></p>
												</div>
											</div>
										</div>
									)
								})}
								{/* <div className="card">
									<div className="card-header" id="headingOne">
										<h5 className="mb-0">
											<button className="btn btn-link" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
												<span>Lorem Ipsum is simply dummy text of the printing and typesetting</span>
												<span className="arrow-icon ml-2">
													<i className="fa fa-angle-down"></i>
												</span>
											</button>
										</h5>
									</div>
									<div id="collapseOne" className="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
										<div className="card-body">
											Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting.
										</div>
									</div>
								</div>
								<div className="card">
									<div className="card-header" id="headingTwo">
										<h5 className="mb-0">
											<button className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
												<span>Lorem Ipsum is simply dummy text of the printing and typesetting</span>
												<span className="arrow-icon ml-2">
													<i className="fa fa-angle-down"></i>
												</span>
											</button>
										</h5>
									</div>
									<div id="collapseTwo" className="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
										<div className="card-body">
											Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting.
										</div>
									</div>
								</div>
								<div className="card">
									<div className="card-header" id="headingThree">
										<h5 className="mb-0">
											<button className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
												<span>Lorem Ipsum is simply dummy text of the printing and typesetting</span>
												<span className="arrow-icon ml-2">
													<i className="fa fa-angle-down"></i>
												</span>
											</button>
										</h5>
									</div>
									<div id="collapseThree" className="collapse" aria-labelledby="headingThree" data-parent="#accordion">
										<div className="card-body">
											Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting.
										</div>
									</div>
								</div> */}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default HelpFaq
